import { useState } from 'react'
import { Button } from 'react-bootstrap'
import { PremiumPlanPaymentPopup } from 'web_core/assets/subscription/PremiumPlanPaymentPopup'
import { useAccount } from 'web_core/context/account'
import { useAuthState } from 'web_core/firebase/hooks'
import { Designed } from 'web_core/types'
import { logEvent } from 'web_core/utils'

type Props = {
  // イベント収集用
  location: 'top' | 'footer' | 'sticky'
  variant: 'primary' | 'light'
}

export const ActionButton = ({
  location,
  variant,
  ...props
}: Designed<Props>) => {
  const { account } = useAccount()
  const { showSignInPopup } = useAuthState()
  const [showSubscribeModal, setShowSubscribeModal] = useState(false)

  if (account === null) {
    // アカウント登録をしていないユーザの場合
    return (
      <Button
        variant={variant}
        {...props}
        onClick={() => {
          logEvent(`tap_pricing_${location}_free_trial`, { isSignedIn: false })
          showSignInPopup()
        }}
      >
        1週間無料で体験
      </Button>
    )
  } else if (account === undefined || account.plan !== 'Free') {
    // ユーザ情報が確認できていない場合およびFreeではない場合
    return <></>
  } else if (account.plan === 'Free') {
    // Freeプランに契約している場合
    return (
      <>
        <PremiumPlanPaymentPopup
          onHide={() => setShowSubscribeModal(false)}
          show={showSubscribeModal}
          introduction={false}
        />
        <Button
          variant={variant}
          {...props}
          onClick={() => {
            // プランページからのイベント収集
            account.has_tried_premium_plan === true
              ? logEvent(`tap_pricing_${location}_subscribe`)
              : logEvent(`tap_pricing_${location}_free_trial`, {
                  isSignedIn: true,
                })
            setShowSubscribeModal(true)
          }}
        >
          {account.has_tried_premium_plan
            ? 'プランを開始する'
            : '1週間無料で体験'}
        </Button>
      </>
    )
  } else {
    throw new Error('Unreachable')
  }
}
